/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePlanRequestDto
 */
export interface CreatePlanRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreatePlanRequestDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlanRequestDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlanRequestDto
     */
    priority?: CreatePlanRequestDtoPriorityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePlanRequestDto
     */
    active?: boolean;
    /**
     * Days ahead of due date when ticket generation may create a Preventive Ticket (default 90)
     * @type {number}
     * @memberof CreatePlanRequestDto
     */
    schedulingHorizonDays?: number;
}


/**
 * @export
 */
export const CreatePlanRequestDtoPriorityEnum = {
    Low: 'LOW',
    Medium: 'MEDIUM',
    High: 'HIGH'
} as const;
export type CreatePlanRequestDtoPriorityEnum = typeof CreatePlanRequestDtoPriorityEnum[keyof typeof CreatePlanRequestDtoPriorityEnum];


/**
 * Check if a given object implements the CreatePlanRequestDto interface.
 */
export function instanceOfCreatePlanRequestDto(value: object): value is CreatePlanRequestDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreatePlanRequestDtoFromJSON(json: any): CreatePlanRequestDto {
    return CreatePlanRequestDtoFromJSONTyped(json, false);
}

export function CreatePlanRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePlanRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'name': json['name'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'active': json['active'] == null ? undefined : json['active'],
        'schedulingHorizonDays': json['schedulingHorizonDays'] == null ? undefined : json['schedulingHorizonDays'],
    };
}

export function CreatePlanRequestDtoToJSON(json: any): CreatePlanRequestDto {
    return CreatePlanRequestDtoToJSONTyped(json, false);
}

export function CreatePlanRequestDtoToJSONTyped(value?: CreatePlanRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
        'priority': value['priority'],
        'active': value['active'],
        'schedulingHorizonDays': value['schedulingHorizonDays'],
    };
}

